// Batch A — reference article-page screenshots for the marketing board (Dev1, 2026-07-14).
// 139 real article pages across 13 sources (operators / thought-leaders / media),
// captured with Playwright (1280x2000 @2x) and hosted on R2. Leo wires batch-a + batch-b
// into the Article Research board band. Sibling file: articles-batch-b.ts (Dev2).
export type BatchArticle = { title: string; url: string; img: string };
export type BatchCompany = { company: string; tag: string; articles: BatchArticle[] };

export const articlesBatchA: BatchCompany[] = [
  {
    "company": "One Useful Thing (Ethan Mollick)",
    "tag": "operator · Wharton prof · practical AI",
    "articles": [
      {
        "title": "Choosing to Stay Human",
        "url": "https://www.oneusefulthing.org/p/choosing-to-stay-human",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/59f6f814-3013-4816-b9df-46db3c4eb921-a-a0-0-thumb.jpg"
      },
      {
        "title": "Thinking Like an AI",
        "url": "https://www.oneusefulthing.org/p/thinking-like-an-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d76c0195-90f8-4674-966c-01080c787471-a-a0-1-thumb.jpg"
      },
      {
        "title": "15 Times to Use AI, and 5 Not to",
        "url": "https://www.oneusefulthing.org/p/15-times-to-use-ai-and-5-not-to",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d7ecf1f1-f56d-4f21-beff-07b26332adac-a-a0-2-thumb.jpg"
      },
      {
        "title": "The Shape of the Thing",
        "url": "https://www.oneusefulthing.org/p/the-shape-of-the-thing",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/fd5a155e-009b-4eb3-ba15-8fe0f395557c-a-a0-3-thumb.jpg"
      },
      {
        "title": "Management as AI Superpower",
        "url": "https://www.oneusefulthing.org/p/management-as-ai-superpower",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5dcbd6ed-ae4e-4338-9780-68efe1788a5a-a-a0-4-thumb.jpg"
      },
      {
        "title": "Signs and Portents",
        "url": "https://www.oneusefulthing.org/p/signs-and-portents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7e09dd21-c02a-4003-a4ab-da09b4bc3ce4-a-a0-5-thumb.jpg"
      },
      {
        "title": "Centaurs and Cyborgs on the Jagged Frontier",
        "url": "https://www.oneusefulthing.org/p/centaurs-and-cyborgs-on-the-jagged",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8c2d04f0-98ad-4f61-824a-536729c645d4-a-a0-6-thumb.jpg"
      },
      {
        "title": "Superhuman?",
        "url": "https://www.oneusefulthing.org/p/superhuman",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c44a4434-f60d-4b76-9547-34e9e0cbf15e-a-a0-7-thumb.jpg"
      },
      {
        "title": "On Working with Wizards",
        "url": "https://www.oneusefulthing.org/p/on-working-with-wizards",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/61477828-5cd4-42b4-a5fc-35f5c4226317-a-a0-8-thumb.jpg"
      },
      {
        "title": "Real AI Agents and Real Work",
        "url": "https://www.oneusefulthing.org/p/real-ai-agents-and-real-work",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f4ffae22-207a-4c39-b353-1bd1ca690b12-a-a0-9-thumb.jpg"
      },
      {
        "title": "Innovation through Prompting",
        "url": "https://www.oneusefulthing.org/p/innovation-through-prompting",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7c116502-750c-4c8a-b4ca-7e42e25b2ec1-a-a0-10-thumb.jpg"
      }
    ]
  },
  {
    "company": "Lenny's Newsletter (Lenny Rachitsky)",
    "tag": "product/growth · #1 PM newsletter",
    "articles": [
      {
        "title": "The New AI Growth Playbook for 2026 (Elena Verna)",
        "url": "https://www.lennysnewsletter.com/p/the-new-ai-growth-playbook-for-2026-elena-verna",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/6212e1c0-e8f8-4fa0-8f63-c23bb984be12-a-a1-0-thumb.jpg"
      },
      {
        "title": "Counterintuitive Advice for Building AI Products",
        "url": "https://www.lennysnewsletter.com/p/counterintuitive-advice-for-building",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/26fa2e3d-193e-4aa3-b651-34dedbf1278f-a-a1-1-thumb.jpg"
      },
      {
        "title": "AI Tools Are Overdelivering: Large-Scale Productivity Survey",
        "url": "https://www.lennysnewsletter.com/p/ai-tools-are-overdelivering-results-c08",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ffc7a233-753e-456d-ad9f-1a1321de256b-a-a1-2-thumb.jpg"
      },
      {
        "title": "Pricing and Scaling Your AI Product (Madhavan Ramanujam)",
        "url": "https://www.lennysnewsletter.com/p/pricing-and-scaling-your-ai-product-madhavan-ramanujam",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5957c0b8-d5da-4ac4-9c92-405daac37260-a-a1-3-thumb.jpg"
      },
      {
        "title": "How Perplexity Builds Product",
        "url": "https://www.lennysnewsletter.com/p/how-perplexity-builds-product",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/430beda5-0710-4201-bed3-a01e212d640e-a-a1-4-thumb.jpg"
      },
      {
        "title": "How AI Is Reshaping the Product Role",
        "url": "https://www.lennysnewsletter.com/p/how-ai-is-reshaping-the-product-role",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/eb167b82-0f32-4c2a-a348-4183a2ad1b97-a-a1-5-thumb.jpg"
      },
      {
        "title": "How to Build AI Product Sense",
        "url": "https://www.lennysnewsletter.com/p/how-to-build-ai-product-sense",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d3e6e545-706a-4a3c-af1c-b9ac18c77fe5-a-a1-6-thumb.jpg"
      },
      {
        "title": "How Anthropic's Product Team Moves Faster Than Anyone Else",
        "url": "https://www.lennysnewsletter.com/p/how-anthropics-product-team-moves",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8c8f735f-4f86-4cca-af82-746ef229a4c1-a-a1-7-thumb.jpg"
      },
      {
        "title": "Beyond Vibe Checks: A PM's Complete Guide to Evals",
        "url": "https://www.lennysnewsletter.com/p/beyond-vibe-checks-a-pms-complete",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b677ee63-a659-4733-ba05-b6c81612df78-a-a1-8-thumb.jpg"
      },
      {
        "title": "Everyone Should Be Using Claude Code More",
        "url": "https://www.lennysnewsletter.com/p/everyone-should-be-using-claude-code",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d77fd08e-7b9c-469e-a619-e0c434519aa9-a-a1-9-thumb.jpg"
      },
      {
        "title": "How to Build Your Own AI Developer Tools with Claude Code",
        "url": "https://www.lennysnewsletter.com/p/this-week-on-how-i-ai-how-to-build",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/99b255b4-d928-44b9-9dd0-d7f7717f98c4-a-a1-10-thumb.jpg"
      },
      {
        "title": "What People Are Vibe Coding (and Actually Using)",
        "url": "https://www.lennysnewsletter.com/p/what-people-are-vibe-coding-and-actually",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ab6bc97d-f07c-4a03-8353-35d1a81c9dfd-a-a1-11-thumb.jpg"
      },
      {
        "title": "How Top PMs Increase Their Leverage with AI",
        "url": "https://www.lennysnewsletter.com/p/how-top-pms-increase-their-leverage",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4594ebaa-a33a-44fc-a596-f96a03d1a3a9-a-a1-12-thumb.jpg"
      },
      {
        "title": "Why AI Evals Are the Hottest New Skill for Product Builders",
        "url": "https://www.lennysnewsletter.com/p/why-ai-evals-are-the-hottest-new-skill",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/be26f9c0-f6ed-413e-8afd-3079023e03f8-a-a1-13-thumb.jpg"
      },
      {
        "title": "Head of Claude Code: What Happens After Coding Is Solved",
        "url": "https://www.lennysnewsletter.com/p/head-of-claude-code-what-happens",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ddfa7ccf-c03c-4db3-92df-4f6741225310-a-a1-14-thumb.jpg"
      },
      {
        "title": "Best of Lenny's Newsletter 2025",
        "url": "https://www.lennysnewsletter.com/p/best-of-lennys-newsletter-2026",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e8afb081-26b2-4be2-9c6c-cb951ee6d741-a-a1-15-thumb.jpg"
      }
    ]
  },
  {
    "company": "Every.to (Dan Shipper / Chain of Thought)",
    "tag": "media · AI writing + product essays",
    "articles": [
      {
        "title": "Writing as a Way of Thinking",
        "url": "https://every.to/chain-of-thought/writing-as-a-way-of-thinking",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2b002a70-e90c-41b2-b352-93479c0578e7-a-a2-0-thumb.jpg"
      },
      {
        "title": "Writing Essays With AI: A Guide",
        "url": "https://every.to/chain-of-thought/writing-essays-with-ai-a-guide",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c6ffe80e-be1d-407c-9710-2baf2c8d128e-a-a2-1-thumb.jpg"
      },
      {
        "title": "A Few Things I Believe About AI",
        "url": "https://every.to/chain-of-thought/a-few-things-i-believe-about-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/be8477f9-a2fa-4cb7-8511-44f1507bb92e-a-a2-2-thumb.jpg"
      },
      {
        "title": "AI-assisted Decision-making",
        "url": "https://every.to/chain-of-thought/ai-assisted-decision-making",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d36a8915-d094-4f37-83d2-b08c96ab8afd-a-a2-3-thumb.jpg"
      },
      {
        "title": "Seeing Creativity Like a Language Model",
        "url": "https://every.to/chain-of-thought/seeing-creativity-like-a-language-model",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/111790f5-95bb-4a0d-8c08-53da155e40f9-a-a2-4-thumb.jpg"
      },
      {
        "title": "The Knowledge Economy Is Over. Welcome to the Allocation Economy.",
        "url": "https://every.to/chain-of-thought/the-knowledge-economy-is-over-welcome-to-the-allocation-economy",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c06d0fa8-bf9c-4f1a-a51a-15ccc76f5f0a-a-a2-5-thumb.jpg"
      },
      {
        "title": "The Magic Minimum for AI Agents",
        "url": "https://every.to/chain-of-thought/the-magic-minimum-for-ai-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/bb736ee8-5071-4e6c-b7e7-99e6117af5a5-a-a2-6-thumb.jpg"
      },
      {
        "title": "When Your Vibe Coded App Goes Viral—And Then Goes Down",
        "url": "https://every.to/chain-of-thought/when-your-vibe-coded-app-goes-viral-and-then-goes-down",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/a7ce9d84-2fcc-42f0-b396-f1d41ed55906-a-a2-7-thumb.jpg"
      },
      {
        "title": "What Are AI Agents—And Who Profits From Them?",
        "url": "https://every.to/napkin-math/what-are-ai-agents-and-who-profits-from-them",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b577d28e-e1ca-4578-8797-c22127da157c-a-a2-8-thumb.jpg"
      },
      {
        "title": "How to Build a Truly Useful AI Product",
        "url": "https://every.to/thesis/how-to-build-a-truly-useful-ai-product",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c4c90637-f2f1-423a-bd0c-95dd81a07e74-a-a2-9-thumb.jpg"
      },
      {
        "title": "How to Build an AI Style Guide",
        "url": "https://every.to/guides/how-to-build-an-ai-style-guide",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9d8dea0b-2fd8-4c63-80b1-a593d8ec950d-a-a2-10-thumb.jpg"
      },
      {
        "title": "Agent-native Product Management",
        "url": "https://every.to/guides/ai-product-management-guide",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b33ba021-8229-4c8c-94c4-4f8b7fb01ff1-a-a2-11-thumb.jpg"
      },
      {
        "title": "Compound Engineering",
        "url": "https://every.to/guides/compound-engineering",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/da7ae1d0-510a-407c-9b48-f590143b0bbd-a-a2-12-thumb.jpg"
      },
      {
        "title": "Agent-native Architectures",
        "url": "https://every.to/guides/agent-native",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e889949a-6d71-4d3c-8159-79d3bafe7728-a-a2-13-thumb.jpg"
      },
      {
        "title": "An Executive's Guide to Implementing AI",
        "url": "https://every.to/guides/an-executive-s-guide-to-implementing-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8a609403-4bea-42cd-a2b6-01a202f550d6-a-a2-14-thumb.jpg"
      }
    ]
  },
  {
    "company": "Marketing AI Institute (Paul Roetzer)",
    "tag": "closest peer · AI-for-marketing education",
    "articles": [
      {
        "title": "Dharmesh Shah and Paul Roetzer on Marketing Technology and AI",
        "url": "https://www.marketingaiinstitute.com/blog/dharmesh-shah-paul-roetzer-marketing-technology-artificial-intelligence",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d9fdeb31-13b9-4cc4-9d98-acda11490b49-a-a3-0-thumb.jpg"
      },
      {
        "title": "How to Prepare Knowledge Workers for an AI-Powered Future",
        "url": "https://www.marketingaiinstitute.com/blog/marketing-ai-conference-paul-roetzer",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9cafaa9c-c63e-4ea9-bc5c-beb10f628da2-a-a3-1-thumb.jpg"
      },
      {
        "title": "Marketing Artificial Intelligence (Book Launch)",
        "url": "https://www.marketingaiinstitute.com/blog/new-book-launch-marketing-artificial-intelligence-ai-marketing-and-the-future-of-business",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c7d9f3ec-5479-43a4-8776-204a74008405-a-a3-2-thumb.jpg"
      },
      {
        "title": "The 5Ps of Marketing Artificial Intelligence",
        "url": "https://www.marketingaiinstitute.com/blog/the-5ps-of-marketing-artificial-intelligence",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e07fbe9a-33f4-4d0e-bae1-006c9b157b3c-a-a3-3-thumb.jpg"
      },
      {
        "title": "How AI Will Impact SEO",
        "url": "https://www.marketingaiinstitute.com/blog/ai-seo-impact",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c6ef95f6-1681-45b7-a380-a2e9946907fb-a-a3-4-thumb.jpg"
      },
      {
        "title": "ChatGPT Agent Is Here",
        "url": "https://www.marketingaiinstitute.com/blog/chatgpt-agent",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8722c3ed-655a-40fd-9ddb-28ecbae13c84-a-a3-5-thumb.jpg"
      },
      {
        "title": "This Tool Forecasts New Jobs That AI Will Create",
        "url": "https://www.marketingaiinstitute.com/blog/future-of-work",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/63758481-42c4-409e-94c6-cfe75f131a40-a-a3-6-thumb.jpg"
      },
      {
        "title": "JobsGPT: The AI Tool Assessing the Future of Work",
        "url": "https://www.marketingaiinstitute.com/blog/jobsgpt",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/09dd9302-16de-45b2-a130-4dcc7e80c205-a-a3-7-thumb.jpg"
      },
      {
        "title": "74% of Professionals Call AI Essential But Their Companies Lag",
        "url": "https://www.marketingaiinstitute.com/blog/ai-b2b-marketers-summit-adoption",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/92cba2c2-8249-4ec9-a1b7-c3fb4879cc7f-a-a3-8-thumb.jpg"
      },
      {
        "title": "Two Things Every B2B Marketer Should Be Doing With AI Now",
        "url": "https://www.marketingaiinstitute.com/blog/b2b-marketers-summit-ai-orchestrator",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/8f6ea3a0-aad8-41e5-90bc-f58e4eb68b29-a-a3-9-thumb.jpg"
      },
      {
        "title": "How AI Will Change Marketing Jobs of the Future",
        "url": "https://www.marketingaiinstitute.com/blog/how-marketing-jobs-will-evolve-in-the-future",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b12bb864-79fa-4365-a243-6af4c17117a1-a-a3-10-thumb.jpg"
      },
      {
        "title": "40% of Jobs Will Be Impacted by AI, Says IMF",
        "url": "https://www.marketingaiinstitute.com/blog/impact-of-ai-on-jobs",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cbbeb46a-2e3e-4fe7-b341-d2b5ae1f57b9-a-a3-11-thumb.jpg"
      },
      {
        "title": "How Artificial Intelligence Will Redefine Marketing Jobs",
        "url": "https://www.marketingaiinstitute.com/blog/how-artificial-intelligence-will-redefine-marketing-jobs",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/96314354-0369-409d-9b69-b8e4383f73a3-a-a3-12-thumb.jpg"
      },
      {
        "title": "Will Marketing Be Automated by AI?",
        "url": "https://www.marketingaiinstitute.com/blog/is-my-marketing-job-going-to-be-replaced-by-artificial-intelligence",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/80facd88-d5be-4de9-b0a7-153b3a410ad3-a-a3-13-thumb.jpg"
      }
    ]
  },
  {
    "company": "The Rundown AI (Rowan Cheung)",
    "tag": "media · 2M+ daily AI newsletter",
    "articles": [
      {
        "title": "OpenAI's AI Phone Just Jumped the Line",
        "url": "https://www.therundown.ai/p/openai-ai-phone-just-jumped-the-line",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5f8a5ffe-99f0-4d2b-bfa6-db11c1d19218-a-a4-0-thumb.jpg"
      },
      {
        "title": "The Part of Claude's Brain Nobody Built",
        "url": "https://www.therundown.ai/p/the-part-of-claude-s-brain-nobody-built",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/7c51b1ca-fc2f-4e27-98ee-7e9e3385ffdc-a-a4-1-thumb.jpg"
      },
      {
        "title": "Perplexity's Agent Pivot Is on the Money",
        "url": "https://www.therundown.ai/p/perplexity-agent-pivot-is-on-the-money",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/70c5f3f8-c736-48f6-8660-f24c8ca5e7b6-a-a4-2-thumb.jpg"
      },
      {
        "title": "Claude Code's ChatGPT Moment for 'Selfware'",
        "url": "https://www.therundown.ai/p/claude-code-sparks-selfware-era",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/22925403-bf5f-4f1b-a3f5-938e9856e9c8-a-a4-3-thumb.jpg"
      },
      {
        "title": "Meta Sizes Up GPT-5.5 with 'Watermelon'",
        "url": "https://www.therundown.ai/p/meta-sizes-up-gpt-5-5-with-watermelon",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/90b55b66-43d1-4fab-9274-2abcc34d2412-a-a4-4-thumb.jpg"
      },
      {
        "title": "Nvidia Corners the AI Agent Stack",
        "url": "https://www.therundown.ai/p/nvidia-corners-the-ai-agent-stack",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/480c5bf8-683e-4f28-9c97-0e36c3363491-a-a4-5-thumb.jpg"
      }
    ]
  },
  {
    "company": "The Neuron (Pete Huang)",
    "tag": "media · practical daily AI newsletter",
    "articles": [
      {
        "title": "How to Actually Use AI in 2026: The 5-Level Stack",
        "url": "https://www.theneurondaily.com/p/this-is-how-we-d-teach-ai-from-scratch-in-2026",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/be3f76a9-1336-4b8e-9cbc-f20761a4d2a5-a-a5-0-thumb.jpg"
      },
      {
        "title": "Skills vs Projects vs Custom GPT vs Agents vs Plugins",
        "url": "https://www.theneurondaily.com/p/watch-skills-vs-projects-vs-custom-gpt-vs-agents-vs-plugins-vs",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/86a7fdc9-3b7b-48f6-8aa8-095609613dcf-a-a5-1-thumb.jpg"
      },
      {
        "title": "How to Build Your Own Agent",
        "url": "https://www.theneurondaily.com/p/how-to-build-your-own-agent",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/53698dc9-1160-4f91-8bf1-26d68d4c9e50-a-a5-2-thumb.jpg"
      },
      {
        "title": "REVEALED: How We Use AI at The Neuron",
        "url": "https://www.theneurondaily.com/p/revealed-use-ai-neuron",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/0a141aff-1d04-4896-a429-5f6428bf2bd0-a-a5-3-thumb.jpg"
      },
      {
        "title": "The 50+ AI Tools Neuron Readers ACTUALLY Pay For",
        "url": "https://www.theneurondaily.com/p/the-50-ai-tools-neuron-readers-actually-pay-for-b7bc",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/68b693d1-2ae2-4e36-82ec-23290dd17b20-a-a5-4-thumb.jpg"
      },
      {
        "title": "Everyone's Building Their Own Apps Now. SaaS Is Terrified.",
        "url": "https://www.theneurondaily.com/p/everyone-s-building-their-own-apps-now-saas-companies-are-terrified",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/859659b2-2bea-488a-9a4a-7f5a92aa1c20-a-a5-5-thumb.jpg"
      },
      {
        "title": "Claude Is Now the #1 Business AI",
        "url": "https://www.theneurondaily.com/p/claude-is-now-the-1-business-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/40cef167-715f-4ed9-8567-d0d2f9042222-a-a5-6-thumb.jpg"
      },
      {
        "title": "Top 13 AI Insights",
        "url": "https://www.theneurondaily.com/p/top-13-ai-insights",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/03e7ab81-4b27-4198-89f9-089bb2683644-a-a5-7-thumb.jpg"
      }
    ]
  },
  {
    "company": "Ben's Bites (Ben Tossell)",
    "tag": "media · AI builders newsletter",
    "articles": [
      {
        "title": "Let AI Point It Out",
        "url": "https://www.bensbites.com/p/let-ai-point-it-out",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f8078317-b8dd-4893-ae99-f6e47030b5e8-a-a6-0-thumb.jpg"
      },
      {
        "title": "BB Digest: Guess Where I Am?",
        "url": "https://www.bensbites.com/p/bb-digest-guess-where-i-am",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/adbb53dc-1b6a-4534-aa2f-be2181af1df8-a-a6-1-thumb.jpg"
      },
      {
        "title": "Build a Newsletter-Writing GPT (Tutorial)",
        "url": "https://catalog.bensbites.com/tutorial/build-a-newsletter-writing-gpt",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e6c25563-efce-430a-9a6c-bcebc30983df-a-a6-2-thumb.jpg"
      }
    ]
  },
  {
    "company": "Superhuman AI (Zain Kahn)",
    "tag": "media · 1M+ reader AI productivity newsletter",
    "articles": [
      {
        "title": "How to Automate Your Work with AI",
        "url": "https://www.superhuman.ai/p/automate-work-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2894e93e-e12b-4f1b-8db3-dba27054b608-a-a7-0-thumb.jpg"
      },
      {
        "title": "The Art of Prompt Engineering",
        "url": "https://www.superhuman.ai/p/art-prompt-engineering",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e1ffc134-86a6-42d4-b911-7b5dcd26a809-a-a7-1-thumb.jpg"
      },
      {
        "title": "The Best AI Tutorials and Guides from 2024",
        "url": "https://www.superhuman.ai/p/the-best-ai-tutorials-and-guides-from-2024",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e8e57a0f-c422-49bd-b757-856e367607cd-a-a7-2-thumb.jpg"
      },
      {
        "title": "How to Automate Work with ChatGPT",
        "url": "https://www.superhuman.ai/p/automate-work-chatgpt",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9fae22a9-1d14-4653-b3e4-8c3de618108b-a-a7-3-thumb.jpg"
      },
      {
        "title": "OpenAI Drops New Agentic Tools for Developers",
        "url": "https://www.superhuman.ai/p/openai-drops-new-agentic-tools-for-developers",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/dd58e1b6-51b8-428b-99c6-4811ee70cbc0-a-a7-4-thumb.jpg"
      },
      {
        "title": "GPT-2: The Mystery AI Model",
        "url": "https://www.superhuman.ai/p/gpt2-mystery-ai-model",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c5933022-75f5-415d-93fe-56085d806db4-a-a7-5-thumb.jpg"
      },
      {
        "title": "ChatGPT Prompt Cheat Sheet: A 2025 Guide",
        "url": "https://www.superhuman.ai/prompts-cheat-sheet",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/970473fc-51b0-4899-9948-f07a077ed118-a-a7-6-thumb.jpg"
      },
      {
        "title": "11 Best AI Newsletters to Stay on Top of AI Trends",
        "url": "https://www.superhuman.ai/best-ai-newsletters",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4495e7c0-da05-41b8-95e3-760663f06f39-a-a7-7-thumb.jpg"
      }
    ]
  },
  {
    "company": "Exponential View (Azeem Azhar)",
    "tag": "analyst · AI economy + strategy",
    "articles": [
      {
        "title": "Is AI a Bubble?",
        "url": "https://www.exponentialview.co/p/is-ai-a-bubble",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b42848ea-99d1-43c6-b61f-1d5ab134fded-a-a8-0-thumb.jpg"
      },
      {
        "title": "The State of the AI Economy",
        "url": "https://www.exponentialview.co/p/the-state-of-the-ai-economy",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2a383c0d-1989-47be-bfe1-59b9f4dbd13a-a-a8-1-thumb.jpg"
      },
      {
        "title": "The Infinite-Compute Economy Has Already Started",
        "url": "https://www.exponentialview.co/p/the-infinite-compute-economy-has",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d1a80477-de81-4ab3-9bbc-95a51f53b84b-a-a8-2-thumb.jpg"
      },
      {
        "title": "What I Was Right (and Wrong) About",
        "url": "https://www.exponentialview.co/p/what-i-was-right-and-wrong-about",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b5d4bc51-087d-466a-a91c-e6cfc86e533b-a-a8-3-thumb.jpg"
      },
      {
        "title": "The Work After Work",
        "url": "https://www.exponentialview.co/p/artisan-premium-making-in-2026",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4b6f30cc-9d9b-468c-b2ab-9e3c0b386ef1-a-a8-4-thumb.jpg"
      },
      {
        "title": "The Forces of the Next Five Years",
        "url": "https://www.exponentialview.co/p/the-forces-of-the-next-five-years",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5931ae6f-2def-4518-aa65-fb50690b0298-a-a8-5-thumb.jpg"
      },
      {
        "title": "Behind the Scenes of My AI Agent",
        "url": "https://www.exponentialview.co/p/behind-the-scenes-of-my-ai-agent",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cbe523d3-01fc-4b59-9946-c2796829e3d6-a-a8-6-thumb.jpg"
      },
      {
        "title": "Building with Agents",
        "url": "https://www.exponentialview.co/p/building-with-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cdfb3dbd-aa69-4d74-8405-c97a58c07461-a-a8-7-thumb.jpg"
      },
      {
        "title": "AI in 2030",
        "url": "https://www.exponentialview.co/p/ai-in-2030",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/344b375f-fa6c-4f9a-ac3a-9113ecde674a-a-a8-8-thumb.jpg"
      },
      {
        "title": "New Evidence for AI and the Job Market",
        "url": "https://www.exponentialview.co/p/new-evidence-for-ai-and-the-job-market",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d72d8adb-9e16-4662-be8d-9b425226ba6e-a-a8-9-thumb.jpg"
      },
      {
        "title": "After AI, Where Will the Jobs Come From?",
        "url": "https://www.exponentialview.co/p/after-ai-where-will-the-jobs-come-from",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/a4acf5c3-12f9-458f-af8d-7c87d7b740bd-a-a8-10-thumb.jpg"
      },
      {
        "title": "You Already Have an AI Agent",
        "url": "https://www.exponentialview.co/p/the-boundary-of-tedium-has-moved",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/0346ab5c-944c-443d-b13f-3c5e3ab2c2e2-a-a8-11-thumb.jpg"
      }
    ]
  },
  {
    "company": "HubSpot (AI & Marketing Blog)",
    "tag": "media · marketing SaaS · SEO/AEO authority",
    "articles": [
      {
        "title": "8 Ways to Use AI in Digital Marketing",
        "url": "https://blog.hubspot.com/marketing/ai-marketing",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/294b070d-8053-40bf-8674-567be777fb21-a-a9-0-thumb.jpg"
      },
      {
        "title": "Here's Exactly How the HubSpot Blog Team Uses AI",
        "url": "https://blog.hubspot.com/marketing/how-the-hubspot-blog-team-uses-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/87c6edbd-ea1c-404d-af27-8063992010d5-a-a9-1-thumb.jpg"
      },
      {
        "title": "Implementing AI in Your Marketing Tech Stack",
        "url": "https://blog.hubspot.com/marketing/ai-martech",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b02a9b5d-50cb-46fc-a6e6-aa114917bf6a-a-a9-2-thumb.jpg"
      },
      {
        "title": "A Guide to Integrating AI Tools in Your Marketing Processes",
        "url": "https://blog.hubspot.com/marketing/ai-marketing-processes",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/c4d871b3-ab3e-42c9-ae4f-78a934fad587-a-a9-3-thumb.jpg"
      },
      {
        "title": "AI Marketing Automation: What Marketers Need to Know",
        "url": "https://blog.hubspot.com/marketing/ai-marketing-automation",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2ad27792-62ee-4ce7-9abf-1789ba4c0662-a-a9-4-thumb.jpg"
      },
      {
        "title": "AI in Content Marketing",
        "url": "https://blog.hubspot.com/marketing/ai-in-content-marketing",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/88d81cab-77b1-4ab3-a40d-cc4e0c54b203-a-a9-5-thumb.jpg"
      },
      {
        "title": "How We Build with AI",
        "url": "https://blog.hubspot.com/marketing/how-we-build-with-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/59c206b0-dbd1-4281-be81-56ed90885cd2-a-a9-6-thumb.jpg"
      },
      {
        "title": "I Used AI to Create a Marketing Plan 2 Ways",
        "url": "https://blog.hubspot.com/marketing/ai-marketing-plan",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/74930d2f-24db-47fd-b8fe-69886e9511c7-a-a9-7-thumb.jpg"
      },
      {
        "title": "How to Use AI to Market Your Small Business",
        "url": "https://blog.hubspot.com/marketing/ai-small-business-marketing",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/9ebc5829-0af1-403a-b636-6457bb476480-a-a9-8-thumb.jpg"
      },
      {
        "title": "ChatGPT for SEO: Everything We Know So Far",
        "url": "https://blog.hubspot.com/marketing/chatgpt-for-seo",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d5a771d2-47ac-401c-b8a9-e79bbe5c57c9-a-a9-9-thumb.jpg"
      },
      {
        "title": "AI SEO: How to Use AI to Improve Your SEO Workflow",
        "url": "https://blog.hubspot.com/marketing/ai-seo",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/504f1951-9afc-49df-8f27-0260394e992a-a-a9-10-thumb.jpg"
      },
      {
        "title": "Generative Engine Optimization: What We Know So Far",
        "url": "https://blog.hubspot.com/marketing/generative-engine-optimization",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ecab7168-e087-4fcf-8fc9-1680020b00ca-a-a9-11-thumb.jpg"
      },
      {
        "title": "Is AI-Generated Content Good for SEO?",
        "url": "https://blog.hubspot.com/marketing/ai-generated-content-seo",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ea5264bc-b2cf-49e7-8542-89cf1a9103bf-a-a9-12-thumb.jpg"
      },
      {
        "title": "Answer Engine Optimization (AEO)",
        "url": "https://blog.hubspot.com/marketing/answer-engine-optimization",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/4f758b79-d7bd-4fbf-b7f2-295d21969334-a-a9-13-thumb.jpg"
      },
      {
        "title": "How to Write Content That Generative AI Search Engines Will Cite",
        "url": "https://blog.hubspot.com/marketing/how-to-write-for-ai-search",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1f42315f-1a6d-43ab-bca3-2e1d384c53f3-a-a9-14-thumb.jpg"
      },
      {
        "title": "8 Generative Engine Optimization Best Practices",
        "url": "https://blog.hubspot.com/marketing/generative-engine-optimization-best-practices",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/98cda529-abd6-4f35-9a54-e55defabf301-a-a9-15-thumb.jpg"
      },
      {
        "title": "AI and SEO: What AI Means for the Future of SEO",
        "url": "https://blog.hubspot.com/marketing/how-ai-is-impacting-seo",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/aaee9477-19a6-4fda-a0d8-a9d6e0f423b0-a-a9-16-thumb.jpg"
      },
      {
        "title": "AI Content Optimization: How to Get Found in 2026",
        "url": "https://blog.hubspot.com/marketing/ai-content-optimization",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1c09d597-8e24-4349-8b8e-9ae620b6e721-a-a9-17-thumb.jpg"
      }
    ]
  },
  {
    "company": "Anthropic (News & Engineering)",
    "tag": "lab · the model we build on · agent doctrine",
    "articles": [
      {
        "title": "Equipping Agents for the Real World with Agent Skills",
        "url": "https://www.anthropic.com/engineering/equipping-agents-for-the-real-world-with-agent-skills",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/fdf73289-814d-4b05-bf3f-bff9f7276f9e-a-a10-0-thumb.jpg"
      },
      {
        "title": "Building Effective AI Agents",
        "url": "https://www.anthropic.com/research/building-effective-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ef30289b-af02-4d49-adf8-0ad4047808a3-a-a10-1-thumb.jpg"
      },
      {
        "title": "Scaling Managed Agents: Decoupling the Brain from the Hands",
        "url": "https://www.anthropic.com/engineering/managed-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/d788e7e9-6b9a-4118-a800-be1f342fc2b3-a-a10-2-thumb.jpg"
      },
      {
        "title": "Writing Effective Tools for AI Agents—Using AI Agents",
        "url": "https://www.anthropic.com/engineering/writing-tools-for-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e65cf718-58ae-40a1-b3fe-cc392d82a7d7-a-a10-3-thumb.jpg"
      },
      {
        "title": "Effective Harnesses for Long-Running Agents",
        "url": "https://www.anthropic.com/engineering/effective-harnesses-for-long-running-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/82e3fce3-7a76-4f69-879f-2ed2d0dd867d-a-a10-4-thumb.jpg"
      },
      {
        "title": "Effective Context Engineering for AI Agents",
        "url": "https://www.anthropic.com/engineering/effective-context-engineering-for-ai-agents",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/67f06550-3ecd-4b5f-a8c1-18f5af3e997e-a-a10-5-thumb.jpg"
      },
      {
        "title": "How We Built Our Multi-Agent Research System",
        "url": "https://www.anthropic.com/engineering/multi-agent-research-system",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/09b31ffd-bf53-4300-a5fb-c4aa59af055e-a-a10-6-thumb.jpg"
      },
      {
        "title": "New Capabilities for Building Agents on the Anthropic API",
        "url": "https://www.anthropic.com/news/agent-capabilities-api",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f65c1541-76e1-4c95-a260-aad9b9d7c278-a-a10-7-thumb.jpg"
      },
      {
        "title": "Economic Index: Learning Curves",
        "url": "https://www.anthropic.com/research/economic-index-march-2026-report",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1459a913-172d-4183-83d5-ac9305133c4f-a-a10-8-thumb.jpg"
      },
      {
        "title": "Economic Index: Cadences",
        "url": "https://www.anthropic.com/research/economic-index-june-2026-report",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/afdf8faf-1721-4515-9d23-8873489bb00d-a-a10-9-thumb.jpg"
      },
      {
        "title": "What 81,000 People Told Us About the Economics of AI",
        "url": "https://www.anthropic.com/research/81k-economics",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/370d209f-06b9-4d1b-af77-204d30f5b5b7-a-a10-10-thumb.jpg"
      }
    ]
  },
  {
    "company": "Single Grain (Eric Siu)",
    "tag": "closest peer · revenue marketing agency",
    "articles": [
      {
        "title": "Optimize Content for AI Search with Generative Engine SEO",
        "url": "https://www.singlegrain.com/seo/optimize-content-for-ai-search-with-generative-engine-seo/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e5b61a03-52b9-4063-84d2-541b478f904e-a-a11-0-thumb.jpg"
      },
      {
        "title": "Entity Optimization and AI for Global SEO Growth in 2025",
        "url": "https://www.singlegrain.com/digital-marketing-strategy/entity-optimization-and-ai-for-global-seo-growth-in-2025/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b3bd74b8-7002-4511-b865-e9e364f7cb05-a-a11-1-thumb.jpg"
      },
      {
        "title": "How AI in SEO Simplifies Content Summaries and Link Building",
        "url": "https://www.singlegrain.com/blog/ms/ai-in-seo/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/31037aba-8a25-4e4c-afe7-0551a630d546-a-a11-2-thumb.jpg"
      },
      {
        "title": "How AI SEO Agents Can Boost Online Visibility",
        "url": "https://www.singlegrain.com/artificial-intelligence/how-ai-seo-agents-can-boost-online-visibility/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b6485026-a766-4258-9fe0-a3b3cfe189ea-a-a11-3-thumb.jpg"
      },
      {
        "title": "14 Best Enterprise AI SEO Performance Tracking Services in 2025",
        "url": "https://www.singlegrain.com/search-everywhere-optimization/14-best-enterprise-ai-seo-performance-tracking-services-in-2025-complete-guide/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b0a74ade-fe56-4056-8cf7-b9a49455725f-a-a11-4-thumb.jpg"
      },
      {
        "title": "How AI Transforms the Future of SEO for Startups",
        "url": "https://www.singlegrain.com/search-everywhere-optimization/how-ai-transforms-the-future-of-seo-for-startups/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/b2c1630c-0f2d-4209-9d92-2df36eef2ed8-a-a11-5-thumb.jpg"
      },
      {
        "title": "How to Use AI to Create a Global SEO Strategy in 2025",
        "url": "https://www.singlegrain.com/search-everywhere-optimization/how-to-use-ai-to-create-a-global-seo-strategy-in-2025/",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/2d0799c8-d62c-47bc-a792-b816990d1bc2-a-a11-6-thumb.jpg"
      }
    ]
  },
  {
    "company": "Greg Isenberg (Late Checkout)",
    "tag": "operator · startup ideas + AI businesses",
    "articles": [
      {
        "title": "Find Winning Startup Ideas from AI and Data",
        "url": "https://www.gregisenberg.com/blog/find-winning-startup-ideas-from-ai-and-data",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/cc41fe57-efd4-4255-9364-3d52c2ecdcd5-a-a12-0-thumb.jpg"
      },
      {
        "title": "How to Build a $10M ARR B2B AI Startup",
        "url": "https://www.gregisenberg.com/blog/how-to-build-a-10m-arr-b2b-ai-startup",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5f291947-184e-444d-b16d-4be216ea0aa1-a-a12-1-thumb.jpg"
      },
      {
        "title": "Are You Building This SaaS This Weekend?",
        "url": "https://www.gregisenberg.com/blog/are-you-building-this-saas-this-weekend",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/5351be10-cc70-46c7-8e02-f398b63a9d71-a-a12-2-thumb.jpg"
      },
      {
        "title": "This Is on My Mind",
        "url": "https://www.gregisenberg.com/blog/this-is-on-my-mind",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/acb9c581-9add-4d49-83dd-569b778c5733-a-a12-3-thumb.jpg"
      },
      {
        "title": "AI and Your Job",
        "url": "https://www.gregisenberg.com/blog/ai-and-your-job",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/f6a692c2-4ab2-4c87-83f0-c7ad5197c430-a-a12-4-thumb.jpg"
      },
      {
        "title": "The Mini Guide to Vertical AI",
        "url": "https://www.gregisenberg.com/blog/mini-guide-to-vertical-ai",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/e4db069b-dda9-4909-aa20-5531ede795d3-a-a12-5-thumb.jpg"
      },
      {
        "title": "Vibe Revenue",
        "url": "https://www.gregisenberg.com/blog/vibe-revenue",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/ce958298-55b8-4fad-bbee-8dde8ec8690f-a-a12-6-thumb.jpg"
      },
      {
        "title": "What Kind of Startup Are You Building?",
        "url": "https://latecheckout.substack.com/p/what-kind-of-startup-are-you-building",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/1b82fa81-859c-4163-a21b-9d1f099bbe2c-a-a12-7-thumb.jpg"
      },
      {
        "title": "How to Become an Idea Machine",
        "url": "https://latecheckout.substack.com/p/how-to-become-an-idea-machine",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/0de4a79b-17e3-4919-83f3-48e398520066-a-a12-8-thumb.jpg"
      },
      {
        "title": "The Best $65 I've Ever Spent",
        "url": "https://latecheckout.substack.com/p/the-best-65-ive-ever-spent",
        "img": "https://pub-f9d4dc80715b4656bb344d288227078e.r2.dev/assets/articles-thumb/323efb66-934f-4106-91f0-f4da68967b97-a-a12-9-thumb.jpg"
      }
    ]
  }
];
